/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Touchable } from "frontend/src/components/Touchable"
import { useTrackingData } from "frontend/src/utils/PageContext"
import { useCallback } from "react"
import { useCart } from "frontend/src/utils/useCart"

function CMSLink({
  link: {
    internalRef = undefined,
    externalUrl = undefined,
    urlParameter = undefined,
    cartAction = undefined,
    clickFunction = undefined,
    newtab = false,
    follow = false,
    title = undefined,
    event = undefined,
    pageType = undefined,
    destination = undefined,
    price = undefined,
    section = undefined,
  } = {
    internalRef: undefined,
    externalUrl: undefined,
    urlParameter: undefined,
    cartAction: undefined,
    clickFunction: undefined,
    newtab: false,
    follow: false,
    title: undefined,
    event: undefined,
    pageType: undefined,
    destination: undefined,
    price: undefined,
    section: undefined,
  },
  children = undefined,
  ...props
}) {
  const cart = useCart()
  const pageTrackingData = useTrackingData()
  const trackClick = useCallback(() => {
    if (typeof window !== `undefined`) {
      window.dataLayer.push({
        event: event,
        pageType: pageType,
        destination: destination,
        price: price,
        section: section,
        ...pageTrackingData,
      })
    }
  }, [pageTrackingData, destination, pageType, event, price, section])

  const addToCart = useCallback(() => {
    // cartAction.products.forEach(({ productID, variantID, quantity = 1 }) => {
    //   cart.addMultiple({ productID, variantID }, quantity)
    // })
    cart.addCollection(cartAction.products)
    if (cartAction.coupon) {
      cart.tryCoupon(cartAction.coupon)
    }
    if (cartAction.openCart) {
      cart.show()
    }
  }, [cart, cartAction])

  if (
    internalRef != null &&
    internalRef.hasOwnProperty("slug") &&
    internalRef.slug.hasOwnProperty("current")
  ) {
    const urlString =
      urlParameter && urlParameter.length > 0
        ? urlParameter.map(param => `${param.key}=${param.value}`).join("&")
        : ""
    const internalLink =
      urlString.length > 0
        ? `/${internalRef.slug.current}?${urlString}`
        : `/${internalRef.slug.current}`
    return (
      <Touchable
        role="link"
        to={internalLink}
        title={title}
        event={event}
        onClick={trackClick}
        destination={destination}
        pageType={pageType}
        price={price}
        section={section}
        {...props}
      >
        {children || title}
      </Touchable>
    )
  } else if (
    cartAction != null &&
    cartAction.hasOwnProperty("products") &&
    cartAction.products.length > 0
  ) {
    return (
      <Touchable
        role="button"
        title={title}
        event="AddToCart"
        price={price}
        onClick={() => {
          trackClick()
          addToCart()
        }}
        {...props}
      >
        {children || title}
      </Touchable>
    )
  } else if (clickFunction != null && clickFunction !== "") {
    return (
      <Touchable role="button" title={title} onClick={() => clickFunction()} {...props}>
        {children || title}
      </Touchable>
    )
  } else {
    return (
      <Touchable
        role="link"
        title={title}
        event={event}
        destination={destination}
        href={externalUrl}
        pageType={pageType}
        price={price}
        section={section}
        target={newtab === true ? newtab && "_blank" : undefined}
        rel={follow ? "" : "nofollow"}
        onClick={trackClick}
        {...props}
      >
        {children || title}
      </Touchable>
    )
  }
}

export { CMSLink }
